import React, { useState } from 'react'
import { Link } from 'gatsby'
import { LOCAL_DATA, primary } from '../config/site-content'
import { motion, useScroll, useMotionValueEvent } from 'framer-motion'
import { IServerData } from '../interface/data'
import { skylabApi } from '../config/skylab'
import { useFetch } from '../hooks/use-fetch'
import { contentUrl } from '../utils/db'
interface INavProps {
   serverData?: IServerData
}

const Navbar = () => {
   const { isLoading, error, data } = useFetch(contentUrl)
   const menus = (data?.length > 0 ? data : LOCAL_DATA.siteMenu) as string[];
   const routes = ['', 'sobre', 'portfolio', 'eventos', 'blogs', 'membros', 'servicos', 'testimonial', 'contacto'];
   const menuItems = menus.map((item, index) => ({
      id: index + 1,
      name: item,
      route: routes[index], // Creates a route like "/item-name"
   }));
   const logo = LOCAL_DATA.logotype

   const { scrollY } = useScroll()

   const [hidden, setHidden] = useState(false)
   useMotionValueEvent(scrollY, 'change', (latest) => {
      const previous = scrollY.getPrevious()
      if (latest > previous && latest > 150) {
         setHidden(true)
      } else {
         setHidden(false)
      }
   })

   return (
      <motion.header
         variants={{
            visible: { y: 0 },
            hidden: { y: '-200%' }
         }}
         animate={hidden ? 'hidden' : 'visible'}
         className={`fixed w-full z-10 h-[62px] pb-3 rounded-md ${hidden ? 'bg-transparent' : 'bg-black md:bg-[#00000085]'}`}>
         <nav className='px-4 py-2 flex items-center justify-between lg:px-24 navbar'>
            <div className='w-16'>
               <Link to='/'>
                  <img src={logo} width={400} height={400} alt="logo" />
               </Link>
            </div>
            <div className='nav-menu'>
               <ul className='list-none flex items-center justify-center gap-8'>
                  {menuItems.map((item, index) => (
                     <li key={index + 1} className='relative group'>
                        <Link to={`/${item.route}`} className='text-white'>{item.name}</Link>
                     </li>
                  ))}
               </ul>
            </div>
            <Link to='/contacto' className='bg-primmary p-2 rounded-md text-white hover:bg-orange-600 transition-colors hidden lg:block' style={{ background: primary ? primary : '' }}>Solicitar serviço</Link>
         </nav>
      </motion.header>
   )
}

export default Navbar;
